import { FlexBox, Icon, Text } from '@dixa/lib-shared-habla';

type ConversationIdRestrictedProps = {
  csid: number;
};

export const ConversationIdRestricted = ({
  csid,
}: ConversationIdRestrictedProps): JSX.Element => (
  <FlexBox alignItems="center" gap="200">
    <Text.Paragraph color="neutral.700">#{csid}</Text.Paragraph>
    <Icon name="lock" color="neutral.700" />
  </FlexBox>
);
